module.exports = __webpack_public_path__ + "img/catstagram-details1.fb1a6eca.png";